import { ActivitiesAnalyticalPerGroup } from 'presentation/app/modules/Reports/pages/activities/analyticals/activities-analytical-per-group';
import React from 'react';

export const MakeActivitiesAnalyticalPerGroup: React.FC = () => {
  return <ActivitiesAnalyticalPerGroup />;
};
